import { render, staticRenderFns } from "./CreateCourierMap.vue?vue&type=template&id=1b086630&scoped=true&"
import script from "./CreateCourierMap.vue?vue&type=script&lang=ts&"
export * from "./CreateCourierMap.vue?vue&type=script&lang=ts&"
import style0 from "./CreateCourierMap.vue?vue&type=style&index=0&id=1b086630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b086630",
  null
  
)

/* custom blocks */
import block0 from "./CreateCourierMap.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports